import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Leading Electrical Contracting Company in Chennai
            </h1>
            <p className="hero-subtitle">
              Professional electrical contracting services across India for over 3 years. 
              Licensed electrical contractors specializing in residential, commercial, and industrial 
              electrical contracting solutions with commitment to safety and efficiency.
            </p>
            
            {/* <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">3+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat">
                <span className="stat-number">32+</span>
                <span className="stat-label">Happy Customers</span>
              </div>              
            </div>             */}
            <div className="hero-actions">
              <a href="tel:+918056177577"  className="btn btn-primary btn-large">
                Call Now
              </a>              
            </div>
          </div>
          
          <div className="hero-image">
            <div className="hero-card">
              <div className="card-icon">⚡</div>
              <h3>Expert Electrical Work</h3>
              <p>Licensed electricians for all your electrical needs</p>
            </div>
            <div className="hero-card">
              <div className="card-icon">🏢</div>
              <h3>Commercial & Industrial</h3>
              <p>Professional electrical solutions for businesses</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
